// extracted by mini-css-extract-plugin
export default {"actions":"jitqSo","label":"mhOXfY","switch":"nBr9MW"};